import { defineMessages } from 'react-intl';

/** The copy of the Ditto Music card and its web handoff. design: your-intelligence k1, k2 (§10). */
export const sessionCaptureMessages = defineMessages({
  notConnected: { id: 'app.sml.catalog.ditto.notConnected', defaultMessage: 'not connected' },
  connectedAs: { id: 'app.sml.catalog.ditto.connectedAs', defaultMessage: 'connected · {artist}' },
  signedOut: { id: 'app.sml.catalog.ditto.signedOut', defaultMessage: 'signed out' },
  note: {
    id: 'app.sml.catalog.ditto.note',
    defaultMessage: 'See your stores, countries, playlists and earnings.',
  },
  connectInApp: { id: 'app.sml.catalog.ditto.connectInApp', defaultMessage: 'Connect in the MUSIC24 app' },
  connect: { id: 'app.sml.catalog.connection.connect', defaultMessage: 'Connect' },
  firstRead: {
    id: 'app.sml.catalog.ditto.firstRead',
    defaultMessage: 'Reading your numbers. The first read takes a few minutes.',
  },
  inStreaming: {
    id: 'app.sml.catalog.ditto.inStreaming',
    defaultMessage: 'Stores, countries, playlists and earnings are in Streaming.',
  },
  openStreaming: { id: 'app.sml.catalog.ditto.openStreaming', defaultMessage: 'Open Streaming' },
  syncedToday: { id: 'app.sml.catalog.ditto.syncedToday', defaultMessage: 'Synced today · data through {day}' },
  signedOutNote: {
    id: 'app.sml.catalog.ditto.signedOutNote',
    defaultMessage: 'Ditto signed MUSIC24 out. Your numbers stop at {date}.',
  },
  noArtist: {
    id: 'app.sml.catalog.ditto.noArtist',
    defaultMessage: 'No artist chosen yet, so there are no numbers.',
  },
  reconnect: { id: 'app.sml.catalog.ditto.reconnect', defaultMessage: 'Reconnect' },
  chooseArtist: { id: 'app.sml.catalog.ditto.chooseArtist', defaultMessage: 'Choose artist' },
  changeArtist: { id: 'app.sml.catalog.ditto.changeArtist', defaultMessage: 'Change artist' },
  chooseArtistTitle: { id: 'app.sml.catalog.ditto.chooseArtistTitle', defaultMessage: 'Choose the Ditto artist' },
  changeArtistTitle: { id: 'app.sml.catalog.ditto.changeArtistTitle', defaultMessage: 'Change the Ditto artist' },
  chooseArtistHelp: {
    id: 'app.sml.catalog.ditto.chooseArtistHelp',
    defaultMessage: 'Your Ditto login holds these artists. Pick the one MUSIC24 should read.',
  },
  changeArtistHelp: {
    id: 'app.sml.catalog.ditto.changeArtistHelp',
    defaultMessage:
      'Streaming shows the numbers of one artist. When you pick another artist, MUSIC24 reads that artist from the start. The numbers of {artist} stay stored, and they come back when you pick {artist} again.',
  },
  noArtistsOnLogin: {
    id: 'app.sml.catalog.ditto.noArtistsOnLogin',
    defaultMessage: 'Your Ditto login holds no artist yet. Add an artist on Ditto, then try again.',
  },
  connectTitle: { id: 'app.sml.catalog.ditto.connectTitle', defaultMessage: 'Connect Ditto on your phone' },
  reconnectTitle: { id: 'app.sml.catalog.ditto.reconnectTitle', defaultMessage: 'Reconnect Ditto' },
  googleHint: {
    id: 'app.sml.catalog.ditto.googleHint',
    defaultMessage:
      'Signed up with Google? Set a Ditto password first (Forgot password on Ditto), then log in here with your email.',
  },
  nativeLoginNote: {
    id: 'app.sml.catalog.ditto.nativeLoginNote',
    defaultMessage: 'You log in on Ditto’s own page.',
  },
});

/**
 * The copy of every other card whose sign-in runs on the service's own page in the Music24 app
 * (DistroKid, TuneCore, CD Baby, Apple Music for Artists, UnitedMasters, ...). Ditto Music keeps
 * the copy above.
 */
export const captureMessages = defineMessages({
  note: {
    id: 'app.sml.catalog.capture.note',
    defaultMessage: 'Sign in on the {service} page in the MUSIC24 app on your phone.',
  },
  nativeLoginNote: {
    id: 'app.sml.catalog.capture.nativeLoginNote',
    defaultMessage: 'You sign in on the {service} page. MUSIC24 never sees your password.',
  },
  signInOnlyFirstRead: {
    id: 'app.sml.catalog.capture.signInOnlyFirstRead',
    defaultMessage: 'Connected. This connector is in beta, so your numbers come in over the next few days.',
  },
  noArtistAccess: {
    id: 'app.sml.catalog.capture.noArtistAccess',
    defaultMessage: '{service} has not given you access to an artist yet. Your numbers start when it does.',
  },
  inStreaming: {
    id: 'app.sml.catalog.capture.inStreaming',
    defaultMessage: 'Your numbers are in Streaming.',
  },
  signedOutNote: {
    id: 'app.sml.catalog.capture.signedOutNote',
    defaultMessage: '{service} signed MUSIC24 out. Your numbers stop at {date}.',
  },
  connectTitle: { id: 'app.sml.catalog.capture.connectTitle', defaultMessage: 'Connect {service} on your phone' },
  reconnectTitle: { id: 'app.sml.catalog.capture.reconnectTitle', defaultMessage: 'Reconnect {service}' },
});
